import Button from "@components/Button/Button";
import { GiftAnArticleButtonProps } from "@features/giftAnArticle/utils/types";
import { cn } from "@util/helpers";

const GiftAnArticleButtonVersion4 = ({
  handleClick,
  className,
}: GiftAnArticleButtonProps): React.ReactElement => {
  return (
    <Button
      onClick={handleClick}
      className={cn("border-none text-blue-175 hover:underline", className)}
      testId="action-button-subshare-version-4"
    >
      Gift it to a friend.
    </Button>
  );
};

export default GiftAnArticleButtonVersion4;
